import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/bed-management/')({
  component: () => <Navigate to="/bed-management/requests" />,
  beforeLoad: ({ context }) => {
    if (!context.userAppContext.app) {
      context.userAppContext.storeApp('bed-manager');
    }
  },
});
